import * as React from 'react';
import { type ReactNode } from 'react';
import Sticky from 'react-sticky-el';
import { rgba } from 'polished';
import styled from 'styled-components';

import { useHasMounted } from '../../../hooks/useHasMounted';
import { LOGIN_LINK, SIGNUP_LINK, STICKY } from '../../../utils';
import { Button } from '../../design-system';

import { NavLogo } from './NavLogo';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  width: 100%;
  z-index: 999999;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    margin-bottom: 20px;
  }
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  padding: 20px 40px;
  position: relative;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding: 30px;
  }
`;

const LoginButton = styled(Button)`
  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    padding: 0 10px;
  }
`;

const Buttons = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  position: relative;
`;

const StyledSticky = styled(Sticky)`
  display: flex;
  width: 100%;
  height: 102px;

  /* Not yet sticky */
  > div {
    display: flex;
    width: 100%;
  }

  /* Sticky */
  .isSticky {
    background: ${({ theme }) => rgba(theme.backgroundColor, 0.9)};
    backdrop-filter: blur(8px);
    box-shadow: 0 1px 0 0 ${({ theme }) => theme.borderColor.DEFAULT};
  }
`;

interface NavMinimalProps {
  customAction?: ReactNode;
}

// A minimal nav used currently for landing pages
export const NavMinimal: React.ComponentType<NavMinimalProps> = React.memo(
  ({ customAction }) => {
    const hasMounted = useHasMounted();

    return (
      <HeaderContainer className="fade-in">
        <StyledSticky stickyClassName={STICKY.Element}>
          <Header>
            {hasMounted ? (
              <>
                <NavLogo />
                <Buttons>
                  {customAction || (
                    <>
                      <LoginButton
                        alignText="center"
                        link={LOGIN_LINK}
                        stylez="minimal"
                        text="Log in"
                      />
                      <Button
                        alignText="center"
                        link={`${SIGNUP_LINK}?source=nav`}
                        stylez="loud"
                        text="Get started for free"
                      />
                    </>
                  )}
                </Buttons>
              </>
            ) : null}
          </Header>
        </StyledSticky>
      </HeaderContainer>
    );
  }
);
